function StoreIcon({ type }) {
  if (type === 'apple') {
    return (
      <svg className="store-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M16.6 13.1c0-2.2 1.8-3.3 1.9-3.4-1-1.5-2.6-1.7-3.2-1.7-1.4-.1-2.6.8-3.3.8-.7 0-1.8-.8-3-.8-1.5 0-2.9.9-3.7 2.2-1.6 2.8-.4 6.8 1.1 9.1.8 1.1 1.7 2.3 2.9 2.2 1.2 0 1.6-.7 3-.7s1.8.7 3 .7c1.3 0 2.1-1.1 2.8-2.2.9-1.3 1.2-2.5 1.2-2.6 0 0-2.6-1-2.7-3.6ZM14.4 6.5c.6-.8 1.1-1.9 1-3-.9 0-2 .6-2.7 1.4-.6.7-1.1 1.8-1 2.8 1 .1 2-.5 2.7-1.2Z" />
      </svg>
    );
  }

  return (
    <svg className="store-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4.4 3.6c-.3.2-.4.5-.4.9v15c0 .4.2.7.5.9l8.4-8.4-8.5-8.4Z" />
      <path d="m14.1 10.8 2.4-2.4L6.6 3c-.4-.2-.8-.2-1.1-.1l8.6 7.9Z" />
      <path d="m14.1 13.2-8.6 7.9c.3.1.7.1 1.1-.1l9.9-5.4-2.4-2.4Z" />
      <path d="m19.6 11.1-2-1.1-2.5 2 2.5 2 2-1.1c.6-.3.6-1.5 0-1.8Z" />
    </svg>
  );
}

function StoreDownloadButton({ href, label, type, variant = 'light' }) {
  return (
    <a
      className={variant === 'dark' ? 'store-button store-button--dark' : 'store-button'}
      href={href}
      rel="noreferrer"
      target="_blank"
    >
      <StoreIcon type={type} />
      <span>{label}</span>
    </a>
  );
}

export default StoreDownloadButton;
